import {createApp} from 'vue';
import App from './App.vue';
import {library} from '@fortawesome/fontawesome-svg-core';
import './index.scss';
import {
	faAward,
	faBlockQuestion,
	faCheck,
	faChevronDown,
	faCircleInfo,
	faCoffeePot,
	faDownLeftAndUpRightToCenter,
	faForward,
	faMagnifyingGlass,
	faMusic,
	faPlay,
	faShareNodes,
	faSquare,
	faSquareCheck,
	faXmark,
} from '@fortawesome/pro-regular-svg-icons';

library.add(
	faCircleInfo,
	faBlockQuestion,
	faXmark,
	faMusic,
	faSquareCheck,
	faForward,
	faAward,
	faCoffeePot,
	faPlay,
	faShareNodes,
	faSquare,
	faDownLeftAndUpRightToCenter,
	faCheck,
	faMagnifyingGlass,
	faChevronDown,
);

createApp(App)
	.mount('#app');
